export const _LOAD_PUZZLE_FENCES_MODEL_ = 'Load:PuzzleFencesPuzzle';

export const EDGE_COLORS = {
  path: '#e74c3c',
  fixed: '#2c3e50',
  extra: '#2980b9',
};

export const CELL = {
  id: null,
  positionx: 0,
  positiony: 0,
  value: null,
  edges: {
    top: false, right: false, bottom: false, left: false,
  },
  edgeColors: {
    top: null, right: null, bottom: null, left: null,
  },
  fixedEdges: {
    top: false, right: false, bottom: false, left: false,
  },
  fixedEdgeColors: {
    top: null, right: null, bottom: null, left: null,
  },
  extraEdges: {
    top: false, right: false, bottom: false, left: false,
  },
  extraEdgeColors: {
    top: null, right: null, bottom: null, left: null,
  },
};

export const SETTINGS = {
  showAnswer: true,
  colored: true,
  extraClues: 0,
  baseCluesCount: null,
  rawEdges: null,
};

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  type_id: 7,
  rows: 9,
  columns: 9,
  settings: { ...SETTINGS },
  table: [],
};

export const CELL_SIZE = 60;
